import React, {Component} from 'react';
import IconPerson from "./icons/IconPerson";
import IconParking from "./icons/IconParking";
import IconWifi from "./icons/IconWifi";
import IconAirCondition from "./icons/IconAirCondition";
import IconBeach from "./icons/IconBeach";
import IconJacuzzi from "./icons/IconJacuzzi";
import IconPets from './icons/IconPets'

export default class ApartmentIcons extends Component {
    render() {
        const {
            apartment: {
                area,
                parking,
                wifi,
                air_condition,
                type,
                number_of_people,
                pets
            },
            translations
        } = this.props;

        return (
            <div className="apartment-icons">
                <IconPerson
                    tooltip={translations['apartment-box-max-people']}
                    number_of_people={number_of_people}
                />
                {parking === true &&
                <IconParking
                    tooltip={translations['apartment-box-parking']}
                />
                }
                {wifi === true &&
                <IconWifi
                    tooltip={translations['apartment-box-wifi']}
                />
                }
                {air_condition === true &&
                <IconAirCondition
                    tooltip={translations['apartment-box-air-condition']}
                />
                }
                {pets === true &&
                <IconPets
                    tooltip={translations['amenities.animals']}
                />
                }
                {type === 'syrenka' &&
                <IconBeach/>
                }
                {type === 'morskieoko' &&
                <IconBeach/>
                }
                {type === 'jacuzzi' &&
                <IconJacuzzi/>
                }
                <span className="apartment-icons__area">{area}m<sup>2</sup></span>
            </div>
        );
    }
}